import {
  FETCH_SUPERVISOR_WISE_OT_REQUEST,
  FETCH_SUPERVISOR_WISE_OT_SUCCESS,
  FETCH_SUPERVISOR_WISE_OT_FAILURE,
  FETCH_OT_EMP_NOTLEFT_REQUEST,
  FETCH_OT_EMP_NOTLEFT_SUCCESS,
  FETCH_OT_EMP_NOTLEFT_FAILURE,
  FETCH_LOCATION_NOT_OFF_REQUEST,
  FETCH_LOCATION_NOT_OFF_SUCCESS,
  FETCH_LOCATION_NOT_OFF_FAILURE,
} from "../constants/OTAllocatedConstants";

const initialState = {
  supervisorWiseOT: {
    loading: false,
    data: [],
    error: null,
  },
  locationNotOff: {
    loading: false,
    data: [],
    error: null,
  },
  otEmpNotLeft: {
    loading: false,
    data: [],
    error: null,
  },
};

const OTAllocatedReducer = (state = initialState, action) => {
  switch (action.type) {
    // Supervisor Wise OT
    case FETCH_SUPERVISOR_WISE_OT_REQUEST:
      return { ...state, supervisorWiseOT: { ...state.supervisorWiseOT, loading: true, error: null } };
    case FETCH_SUPERVISOR_WISE_OT_SUCCESS:
      return { ...state, supervisorWiseOT: { loading: false, data: action.payload, error: null } };
    case FETCH_SUPERVISOR_WISE_OT_FAILURE:
      return { ...state, supervisorWiseOT: { ...state.supervisorWiseOT, loading: false, error: action.payload } };

    // Location Not Off
    case FETCH_LOCATION_NOT_OFF_REQUEST:
      return { ...state, locationNotOff: { ...state.locationNotOff, loading: true, error: null } };
    case FETCH_LOCATION_NOT_OFF_SUCCESS:
      return { ...state, locationNotOff: { loading: false, data: action.payload, error: null } };
    case FETCH_LOCATION_NOT_OFF_FAILURE:
      return { ...state, locationNotOff: { ...state.locationNotOff, loading: false, error: action.payload } };

    // OT Emp Not Left
    case FETCH_OT_EMP_NOTLEFT_REQUEST:
      return { ...state, otEmpNotLeft: { ...state.otEmpNotLeft, loading: true, error: null } };
    case FETCH_OT_EMP_NOTLEFT_SUCCESS:
      return { ...state, otEmpNotLeft: { loading: false, data: action.payload, error: null } };
    case FETCH_OT_EMP_NOTLEFT_FAILURE:
      return { ...state, otEmpNotLeft: { ...state.otEmpNotLeft, loading: false, error: action.payload } };

    default:
      return state;
  }
};

export default OTAllocatedReducer;
